module.exports = __webpack_public_path__ + "static/media/overlay5.26db35c0.png";